export default __webpack_public_path__ + "static/img/Letinte69.b451a5c.jpg";